import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { PrintHelpers, PrintHOC } from '../../../components'

export function LoanerDeviceAgreement(props) {
  let { ticket, record, children } = props
  const { agreement } = record
  const { organization } = ticket
  return (
    <ReactBootstrap.Row className="print_zone">
      <ReactBootstrap.Col xs="12" className="p-0 mb-2 text-end d-print-none">
        <span className="pr-3">{children}</span>
      </ReactBootstrap.Col>

      <div className="pl-5 pr-5">
        <ReactBootstrap.Col xs={12}>
          <PrintHelpers.Header
            legend="Loaner Device Agreement"
            organization={organization}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>
            <PrintHelpers.EaseOnBarcode value={ticket.reference_number} />
          </ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-end" xs={6}>
            <PrintHelpers.TimeStamp
              label="Created On"
              value={record.created_at}
            />
            {record.returned_on ? (
              <ReactBootstrap.Alert variant="danger">
                <PrintHelpers.TimeStamp
                  label="Returned On"
                  value={record.returned_on}
                />
              </ReactBootstrap.Alert>
            ) : (
              ''
            )}
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
        <ReactBootstrap.Col xs={12}>
          <p>
            <strong>{organization.name}</strong>
            {agreement.welcome_message}
          </p>
          <p>
            <ol>
              {agreement.terms.map((item, index) => {
                return (
                  <li key={item.heading}>
                    <p>
                      <strong>{item.heading}: </strong>
                      {item.value}
                    </p>
                    {index === 0 ? (
                      <div>
                        <table className="table table-sm">
                          <thead>
                            <tr>
                              <th> Description</th>
                              <th> Serial Number</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr key={index}>
                              <th> {record.inventory_item_description} </th>
                              <td> {record.inventory_item_serial_number} </td>
                            </tr>
                          </tbody>
                        </table>
                        <p>
                          <small>{agreement.confer_notice}.</small>
                        </p>
                        <p>
                          <small>
                            <strong>CONSUMER LAW:</strong>
                            {agreement.consumer_law_info}
                          </small>
                        </p>
                      </div>
                    ) : (
                      ''
                    )}
                    {index === 1 ? (
                      <div>
                        {' '}
                        <table className="table table-sm">
                          <thead>
                            <tr>
                              <th> Description</th>
                              <th> Replacement Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            {record.penalty.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <th> {item.reason} </th>
                                  <td>
                                    <PrintHelpers.Currency value={item.cost} />
                                  </td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      ''
                    )}
                  </li>
                )
              })}
            </ol>
          </p>
        </ReactBootstrap.Col>
        <ReactBootstrap.Row>
           <ReactBootstrap.Col xs={12}>
          <PrintHelpers.TimeStamp
            label="Created On"
            value={ record.created_at}
          />

        </ReactBootstrap.Col>
          <ReactBootstrap.Col xs={5}>
            <div style={{ marginTop: '100px' }}>
              <PrintHelpers.Signature signature={ticket.created_by_signature} />
              <PrintHelpers.InlineText value={record.created_by} />
            </div>
          </ReactBootstrap.Col>
          <ReactBootstrap.Col xs={2}></ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-end" xs={5}>
            <PrintHelpers.Signature signature={record.customer_signature2} />
            <PrintHelpers.InlineText value={'Customer Signature'} />
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </div>
    </ReactBootstrap.Row>
  )
}


export const LoanerDeviceAgreementPrint = PrintHOC(LoanerDeviceAgreement)
